{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Features",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "items"
  ],
  "properties": {
    "items": {
      "title": "Columns",
      "type": "array",
      "maxItems": 6,
      "x-ui": "list",
      "x-itemTitle": "title",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "title",
          "lines"
        ],
        "properties": {
          "title": {
            "title": "Title",
            "type": "string",
            "maxLength": 100
          },
          "lines": {
            "title": "Lines",
            "type": "array",
            "maxItems": 10,
            "x-ui": "list",
            "x-itemTitle": "text",
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "text"
              ],
              "properties": {
                "text": {
                  "title": "Text",
                  "type": "string",
                  "maxLength": 300
                },
                "href": {
                  "title": "Link",
                  "type": "string",
                  "maxLength": 500,
                  "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
                  "x-ui": "link"
                }
              }
            }
          }
        }
      }
    }
  }
}
